import { Injectable } from '@angular/core';
import { CoreWebService } from './core-web.service';
import { RequestMethod } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { LoginService } from './login.service';
import { DotcmsEventsService } from './dotcms-events.service';
import { LoggerService } from './logger.service';
/**
 * Provide methods and data to hable the sites.
 * @export
 * @class SiteService
 */
var SiteService = (function () {
    function SiteService(loginService, dotcmsEventsService, coreWebService, loggerService) {
        var _this = this;
        this.coreWebService = coreWebService;
        this.loggerService = loggerService;
        this.events = [
            'SAVE_SITE',
            'PUBLISH_SITE',
            'UPDATE_SITE_PERMISSIONS',
            'UN_ARCHIVE_SITE',
            'UPDATE_SITE',
            'ARCHIVE_SITE'
        ];
        this._switchSite$ = new Subject();
        this._refreshSites$ = new Subject();
        this.urls = {
            currentSiteUrl: 'v1/site/currentSite',
            sitesUrl: 'v1/site',
            switchSiteUrl: 'v1/site/switch'
        };
        dotcmsEventsService
            .subscribeToEvents(['ARCHIVE_SITE', 'UPDATE_SITE'])
            .subscribe(function (data) { return _this.eventResponse(data); });
        dotcmsEventsService
            .subscribeToEvents(this.events)
            .subscribe(function (data) { return _this.siteEventsHandler(data); });
        loginService.watchUser(function (auth) {
            if (!auth.isLoginAs) {
                _this.loadCurrentSite();
            }
        });
    }
    /**
     * Manage the response when an event happen
     * @param {void} eventTypeWrapper
     * @returns {*}
     * @memberof SiteService
     */
    SiteService.prototype.eventResponse = function (eventTypeWrapper) {
        this.loggerService.debug('Capturing Site event', eventTypeWrapper.eventType, eventTypeWrapper.data);
        // TODO the backend needs a change in the response 'data.data'.
        var siteIdentifier = eventTypeWrapper.data.data.identifier;
        if (siteIdentifier === this.selectedSite.identifier) {
            if (eventTypeWrapper.eventType !== 'ARCHIVE_SITE') {
                this.loadCurrentSite();
            }
        }
    };
    /**
     * Refresh the sites list if a event happen
     * @param {any} eventTypeWrapper
     * @memberof SiteService
     */
    SiteService.prototype.siteEventsHandler = function (eventTypeWrapper) {
        this._refreshSites$.next(eventTypeWrapper.data.data);
    };
    Object.defineProperty(SiteService.prototype, "refreshSites$", {
        /**
         * Observable trigger when an site event happens
         * @readonly
         * @type {Observable<Site>}
         * @memberof SiteService
         */
        get: function () {
            return this._refreshSites$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteService.prototype, "switchSite$", {
        /**
         * Observable tigger when the current site is changed
         * @readonly
         * @type {Observable<Site>}
         * @memberof SiteService
         */
        get: function () {
            return this._switchSite$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteService.prototype, "currentSite", {
        /**
         * Return the current site for the login user.
         * @readonly
         * @type {Site}
         * @memberof SiteService
         */
        get: function () {
            return this.selectedSite;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Switch To Default Site in the BE and returns it.
     *
     * @returns {Observable<Site>}
     * @memberof SiteService
     */
    SiteService.prototype.switchToDefaultSite = function () {
        return this.coreWebService
            .requestView({
            method: RequestMethod.Put,
            url: 'v1/site/switch'
        })
            .pluck('entity');
    };
    /**
     * Get a site by the id
     *
     * @param {string} id
     * @returns {Observable<Site>}
     * @memberof SiteService
     */
    SiteService.prototype.getSiteById = function (id) {
        return this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: "content/render/false/query/+contentType:host%20+identifier:" + id
        })
            .pluck('contentlets')
            .map(function (sites) { return sites[0]; });
    };
    /**
     * Change the current site
     * @param {Site} site
     * @memberof SiteService
     */
    SiteService.prototype.switchSite = function (site) {
        var _this = this;
        this.loggerService.debug('Applying a Site Switch', site.identifier);
        this.coreWebService
            .requestView({
            method: RequestMethod.Put,
            url: this.urls.switchSiteUrl + "/" + site.identifier
        })
            .subscribe(function () { return _this.setCurrentSite(site); });
    };
    SiteService.prototype.setCurrentSite = function (site) {
        if (this.selectedSite) {
            this._switchSite$.next(Object.assign({}, site));
        }
        this.selectedSite = site;
    };
    SiteService.prototype.loadCurrentSite = function () {
        var _this = this;
        this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.urls.currentSiteUrl
        })
            .pluck('entity')
            .subscribe(function (currentSite) {
            _this.setCurrentSite(currentSite);
        });
    };
    SiteService.prototype.getOneSite = function () {
        return this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.urls.sitesUrl
        })
            .map(function (response) {
            return response.entity[0];
        });
    };
    return SiteService;
}());
export { SiteService };
SiteService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
SiteService.ctorParameters = function () { return [
    { type: LoginService, },
    { type: DotcmsEventsService, },
    { type: CoreWebService, },
    { type: LoggerService, },
]; };
//# sourceMappingURL=site.service.js.map